import styled from 'styled-components';

import { Text as UnstyledText } from 'features/common/components/Text';
import { Button as UnstyledButton } from 'features/common/components/Button';

export const Container = styled.div<{ isPunchup?: boolean }>`
	width: 90%;
	padding: 32px;
	background-color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.punchupBackground : theme.colors.grey18)};
	border-radius: 8px;
	border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey19 : theme.colors.grey6)};
	display: flex;
	flex-direction: column;
	gap: 16px;
	height: fit-content;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;

export const Title = styled(UnstyledText)<{ isPunchup?: boolean }>`
	font-size: 20px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.lightGrey7)};
`;

export const TotalPrice = styled(UnstyledText)<{ isPunchup?: boolean }>`
	font-weight: 700;
	font-size: 20px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.lightGrey7)};
`;

export const Price = styled(UnstyledText)<{ isPunchup?: boolean }>`
	font-weight: 700;
	font-size: 16px;
	text-align: end;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.lightGrey7)};

	&.promoCodeApplied {
		opacity: 0.5;
		text-decoration: line-through;
	}
`;

export const Currency = styled(UnstyledText)<{ isPunchup?: boolean }>`
	font-size: 14px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.lightGrey7)};
`;

export const Label = styled(UnstyledText)<{ isPunchup?: boolean }>`
	font-weight: 600;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.lightGrey7)};
	font-size: 16px;
`;

export const Button = styled(UnstyledButton)`
	border-radius: 8px;
	padding: 8px 24px;
	width: 100%;
	height: 50px;
	font-size: 16px;
	margin: 0;
	&:disabled {
		cursor: not-allowed;
		background: ${({ theme }) => theme.colors.lightGrey3};
	}
`;

export const Text = styled(UnstyledText)<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.lightGrey7)};
	font-size: 16px;
`;
